import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  CommonButton,
  EditBusinessDetailsForm,
  GlobalLoader,
  ImageElement,
  ModalComponent,
} from '../../../../../components';
import {
  businessDetailsService,
  editNCABusinessService,
  getNCABusinessService,
  industryService,
  putNcaBUsinessDetailService,
} from '../../../../../services/index.service';
import { Localization } from '../../../../../services/Localization';
import {
  editBusinessDetailsService,
  getBusinessDetailsService,
  updateBusinessDetailsService,
} from '../../../../../services/Providers/provider.service';
import { dateFormatter, logger, modalNotification } from '../../../../../utils';
import { Accordion, Col, Row } from 'react-bootstrap';
import { firstLetterCaps } from '../../../../../utils/text.util';
import { Radio } from 'antd';
import {
  createNCABusinessDetailsService,
  getNCAProfileBusinessService,
} from '../../../../../services/NCA/CreateProfile/ncaCreateProfile.service';
import { accessRegisterRoute } from '../../../../../routes/Auth/ncaRegisterSteps';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { checkValidData } from '../../../../../components/UIElements/Formatter';

const BUSINESS_TYPE = [
  'company_sole',
  'company_single',
  'company_multi',
  'company_private',
  'company_pcorporation',
  'company_unicorporated',
];

function BusinessDetails({
  defaultKey,
  getProfileData,
  ncaEdit = false,
  ncaSignUp = false,
  setDefaultKey,
  ncaProfileKey = false,
  provideEdit = false,
  providerData,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const param = useParams();
  const { id } = param;
  const { t } = useTranslation();

  const [countryCode, setCountryCode] = useState('01');
  const [countryId, setCountryId] = useState();
  const [stateId, setStateId] = useState();
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [formData, setFormData] = useState();
  const [type, setType] = useState('individual');
  const [showModal, setShowModal] = useState(false);
  const [businessType, setBusinessType] = useState('');
  const [radioType, setRadioType] = useState('');
  const [editBusinessType, setEditBusinessType] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [businessPersonDetail, setBusinessPersonDetail] = useState('');
  const [details, setDetails] = useState({ provider: [], loading: true });
  const [businessDetailLoader, setBusinessDetailLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  // Edit mode state — used only in admin (provideEdit=true) context
  const [isEditing, setIsEditing] = useState(false);
  const companyFormRef = useRef(null);
  const repFormRef = useRef(null);

  const handleCombinedSubmit = async () => {
    if (companyFormRef.current) {
      const companyValues = companyFormRef.current.values;
      const isNewTypeIndividual = companyValues.businessType === 'individual';
      
      const companyErrors = await companyFormRef.current.validateForm();
      const cKeys = Object.keys(companyErrors);
      if (cKeys.length > 0) {
        cKeys.forEach((k) => companyFormRef.current.setFieldTouched(k, true));
      }
      
      let repErrors = {};
      let rKeys = [];
      if (!isNewTypeIndividual && repFormRef.current) {
        repErrors = await repFormRef.current.validateForm();
        rKeys = Object.keys(repErrors);
        if (rKeys.length > 0) {
           rKeys.forEach((k) => repFormRef.current.setFieldTouched(k, true));
        }
      }
      
      if (cKeys.length > 0 || rKeys.length > 0) {
        return;
      }
      
      setIsLoading(true);
      
      try {
        if (isNewTypeIndividual) {
          // It was a company, now changed to individual. Only submit companyValues (which holds the individual fields)
          const res = await onSubmit(companyValues, null, true);
          if (res?.success) {
            modalNotification({ type: 'success', message: res.message || 'Business details updated successfully' });
            getBusinessDetails(id);
            setIsEditing(false);
            onCloseModal();
          } else {
            modalNotification({ type: 'error', message: res?.message || 'Failed to update details' });
          }
        } else {
          // Submit both forms sequentially.
          // Mark the rep form with isRepSubmission=true so the backend individual branch
          // knows NOT to delete UserBusinessDetail (schema has allowUnknown:true so this is safe).
          const repValues = { ...repFormRef.current.values, isRepSubmission: true };
          const companyRes = await onSubmit(companyValues, null, true);
          const repRes = await onSubmit(repValues, null, true);

          if (companyRes?.success && repRes?.success) {
            modalNotification({ type: 'success', message: companyRes.message || 'Business details updated successfully' });
            getBusinessDetails(id);
            setIsEditing(false);
            onCloseModal();
          } else {
            if (!companyRes?.success || !repRes?.success) {
               const errorMsg = repRes?.message || companyRes?.message || 'Failed to update all details';
               modalNotification({ type: 'error', message: errorMsg });
            }
          }
        }
      } catch (err) {
        logger(err);
      }
      setIsLoading(false);
    }
  };

  const userType = useSelector((state) => state?.auth?.userData);

  async function onCountryChange(e, formik, getPhoneCode) {
    try {
      const res = await Localization.getStateService({
        type: 'all',
        queryParams: { scope: 'activeState', countryId: e || countryId },
      });
      formik?.setFieldValue(
        'countryPhoneCode',
        getPhoneCode ? getPhoneCode[0] : undefined
      );
      formik?.setFieldValue('stateId', null);
      setCountryCode(getPhoneCode ? getPhoneCode[0] : undefined);
      setState([...res]);
    } catch (err) {
      logger(err);
    }
  }

  async function onStateChange(e, formik, search) {
    try {
      setLoader(true);
      const res = await Localization.ListCityService({
        type: 'all',
        queryParams: {
          scope: 'activeCity',
          ...(search
            ? {
                search: e,
              }
            : {
                stateId: e,
              }),
          ...(search === null && { cityId: formData?.Provider?.City?.id }),
        },
      });
      if (formik) {
        formik?.setFieldValue('cityId', null);
      }
      setCity([...res]);
    } catch (err) {
      console.log(err);
    }
    setLoader(false);
  }

  const onSearchCity = (e, formik) => {
    const handler = setTimeout(() => {
      if (e.length > 2) {
        onStateChange(e, formik, true);
      }
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  };

  async function onSubmit(values, formikHelpers, preventSideEffects = false) {
    setIsLoading(true);
    let response = null;
    try {
      let bodyData = { ...values };
      bodyData.ownershipType = radioType;
      delete bodyData['identityDocumentFrontIdUrl'];
      delete bodyData['identityDocumentBackIdUrl'];
      if (values?.businessType !== 'individual') {
        delete bodyData.socialSecurityNumber;
      }
      // delete bodyData.countryCode;
      delete bodyData.countryPhoneCode;

      response = '';

      if (ncaEdit) {
        response = await editNCABusinessService({ id, bodyData });
      } else if (ncaSignUp) {
        response = await createNCABusinessDetailsService({ bodyData });
      } else if (ncaProfileKey) {
        response = await putNcaBUsinessDetailService({ bodyData });
      } else {
        if (isEditing) {
          response = await updateBusinessDetailsService({ id, bodyData });
        } else {
          response = await editBusinessDetailsService({ id, bodyData });
        }
      }
      const { success, message, data } = response;
      if (success) {
        if (ncaEdit && data?.Nca?.businessType === 'individual') {
          setDefaultKey('bankingDetails');
        }
        if (ncaEdit && data?.UserBusinessPersonDetail?.id) {
          setDefaultKey('bankingDetails');
        }
        //
        if (ncaProfileKey && data?.Nca?.businessType === 'individual') {
          setDefaultKey('bankingDetails');
        }
        if (ncaProfileKey && data?.UserBusinessPersonDetail?.id) {
          setDefaultKey('bankingDetails');
        }
        //
        if (!ncaEdit && !ncaSignUp && !ncaProfileKey) {
          getProfileData();
        }
        if (!preventSideEffects) {
          modalNotification({
            type: 'success',
            message,
          });
          getBusinessDetails(id);
          if (isEditing) {
            // Reset edit mode after a successful save (admin edit context)
            setIsEditing(false);
            onCloseModal();
          }
        }
      }
    } catch (error) {
      logger(error);
    }
    setIsLoading(false);
    return response;
  }

  const getBusinessDetails = async (id) => {
    setBusinessDetailLoader(true);
    try {
      let response = '';
      if (ncaEdit) {
        response = await getNCABusinessService({ id });
      } else if (ncaSignUp) {
        response = await getNCAProfileBusinessService();
      } else if (ncaProfileKey) {
        response = await businessDetailsService();
      } else {
        response = await getBusinessDetailsService(id);
      }

      const { success, data } = response;

      if (success) {
        setFormData(data);

        if (ncaEdit || ncaSignUp || ncaProfileKey) {
          // Remaining testing
          setCountryId(data?.UserBusinessDetail?.Country?.id);
          setBusinessType(data?.Nca?.businessType);
          setBusinessPersonDetail(data?.UserBusinessPersonDetail);

          if (
            data?.Nca?.isPlanCancelled === 1 &&
            userType?.Role?.type === 'nca'
          ) {
            navigate(accessRegisterRoute.CANCEL_COMPANY_PROFILE.path);
          } else if (
            ncaSignUp &&
            data?.Nca?.businessType === 'individual' &&
            data?.Nca?.onBoardingStep > 3
          ) {
            navigate(accessRegisterRoute.BANK_DETAILS.path);
          }
        } else {
          setCountryId(data?.UserBusinessPersonDetail?.countryId);
          setBusinessType(data?.Provider?.businessType);
          setBusinessPersonDetail(data?.UserBusinessPersonDetail);
        }

        const arr = [];
        if (data?.UserBusinessPersonDetail) {
          arr.push(data?.UserBusinessPersonDetail);
        }
        if (data?.UserBusinessDetail) {
          arr.push(data?.UserBusinessDetail);
        }

        if (arr.length === 1 && data?.UserBusinessDetail && !data?.UserBusinessPersonDetail) {
          setShowModal(true);
        }

        setDetails({ data: [...arr], loading: false });
        
        // Fetch states for the dropdown using the correct country ID
        const cId = data?.UserBusinessPersonDetail?.countryId || data?.UserBusinessDetail?.countryAddressId || data?.countryAddressId;
        if (cId) {
          onCountryChange(cId);
        }

        // Pre-populate city list with the saved city so the Select component can display it
        const savedCity = data?.UserBusinessPersonDetail?.city || data?.UserBusinessDetail?.city;
        if (savedCity) {
          setCity([{ name: savedCity }]);
        }
        
        setStateId(data?.stateId);
      }
    } catch (error) {
      logger(error);
    }
    setBusinessDetailLoader(false);
    // setLoading(false);
  };

  const getIndustryList = async () =>
    // id
    {
      try {
        let queryParams = {
          scope: 'activeIndustry',
        };
        const response = await industryService.getIndustryService({
          queryParams,
        });
        setIndustryData([...response?.data?.rows]);
      } catch (error) {
        logger(error);
      }
    };

  useEffect(() => {
    if (countryId) onCountryChange(countryId);
    if (stateId) {
      onStateChange(stateId, false, null);
    }
  }, [countryId, stateId]);

  useEffect(() => {
    if (defaultKey === 'businessDetails') {
      getBusinessDetails(id);
      getIndustryList();
    }
  }, [defaultKey]);

  const onCloseModal = () => {
    if (showModal) {
      setShowModal(false);
    } else {
      setShowForm(false);
    }
    getBusinessDetails(id);
  };

  useEffect(() => {
    setShowForm(!showModal);
  }, [showModal]);

  const onSubmitForm = () => {
    setShowForm(true);
    setShowModal(false);
  };

  useEffect(() => {
    if (defaultKey === 'businessDetails') {
      if (
        businessType === 'individual' ||
        businessType === null ||
        businessPersonDetail
      ) {
        setShowModal(false);
      } else {
        setShowModal(true);
      }
    }
  }, [businessType, defaultKey]);

  const handleChange = (e) => {
    const { value } = e.target;
    setRadioType(value);
  };

  if (details?.loading && !ncaSignUp) {
    return <GlobalLoader />;
  }

  function onBack() {
    setShowModal(true);
    setShowForm(false);
  }

  // Detect company type: rely on UserBusinessDetail existence, NOT Provider.businessType.
  // For company_single accounts, Provider.businessType is set to 'individual' by the second
  // (person-details) API call, making it unreliable. UserBusinessDetail always holds the
  // true company-type record when one exists.
  // FALLBACK: For fresh Add flow, UserBusinessDetail might be delayed, so fallback to checking Provider.businessType.
  const isCompanyType = editBusinessType 
    ? BUSINESS_TYPE.includes(editBusinessType) 
    : (!!formData?.UserBusinessDetail || 
       BUSINESS_TYPE.includes(formData?.Provider?.businessType) || 
       BUSINESS_TYPE.includes(formData?.Nca?.businessType));

  if (isCompanyType) {
    if (provideEdit && isEditing) {
      const companyBusinessType = editBusinessType || formData?.UserBusinessDetail?.businessType;
      const mergedCompanyFormData = formData?.UserBusinessDetail ? {
        ...formData?.UserBusinessDetail,
        businessType: companyBusinessType,
        industryIds: formData?.UserBusinessDetail?.UserBusinessIndustries
          ?.filter((i) => i.status !== 'deleted')
          ?.map((i) => i.industryId),
      } : { businessType: companyBusinessType };

      return (
        <div className="card">
          <div className="card-inner">
            <div className="ncaBusinessDetails">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="title mb-0">{t('text.common.businessDetails')}</h5>
              </div>
              <div className="divider sm"></div>

              {/* ---- Company Details section ---- */}
              <EditBusinessDetailsForm
                isStripeVerified={formData?.isStripeVerified}
                onSubmit={() => {}}
                isLoading={isLoading}
                onCountryChange={onCountryChange}
                state={state}
                onStateChange={onStateChange}
                onSearchCity={onSearchCity}
                loader={loader}
                city={city}
                industryData={industryData}
                countryCode={countryCode}
                formData={mergedCompanyFormData}
                provideEdit={provideEdit}
                providerData={providerData}
                isAdminEdit={true}
                isModal={true} // Removes internal card wrapper
                onCancel={() => {
                  setIsEditing(false);
                  setEditBusinessType(null);
                }}
                formikRef={companyFormRef}
                hideSubmitButtons={true}
                onBusinessTypeChange={(val) => setEditBusinessType(val)}
              />

              {/* ---- Representative Details section ---- */}
              <Row className="mt-3">
                <Accordion defaultActiveKey="0" flush className="p-0 border">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div>
                        <h6>
                          {firstLetterCaps(
                            formData?.UserBusinessPersonDetail?.firstName
                          )}{' '}
                          {firstLetterCaps(
                            formData?.UserBusinessPersonDetail?.lastName
                          )}
                        </h6>
                        <p>
                          Representative, Owner,{` `}
                          {checkValidData(formData?.UserBusinessPersonDetail?.jobTitle)}
                        </p>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="p-3">
                      <EditBusinessDetailsForm
                        isStripeVerified={formData?.isStripeVerified}
                        onSubmit={() => {}}
                        isLoading={isLoading}
                        onCountryChange={onCountryChange}
                        state={state}
                        onStateChange={onStateChange}
                        onSearchCity={onSearchCity}
                        loader={loader}
                        city={city}
                        industryData={industryData}
                        countryCode={countryCode}
                        formData={formData?.UserBusinessPersonDetail}
                        radioType={formData?.UserBusinessPersonDetail?.ownershipType}
                        provideEdit={provideEdit}
                        providerData={providerData}
                        isModal={true}
                        isAdminEdit={true}
                        onCancel={() => {
                          setIsEditing(false);
                          setEditBusinessType(null);
                        }}
                        formikRef={repFormRef}
                        hideSubmitButtons={true}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Row>

              <div className="text-end border-top pt-4 mt-4">
                <CommonButton
                  type="button"
                  className="btn btn-light me-2"
                  onClick={() => {
                    setIsEditing(false);
                    setEditBusinessType(null);
                  }}
                  disabled={isLoading}
                >
                  {t('text.common.cancel')}
                </CommonButton>
                <CommonButton
                  type="button"
                  className="btn btn-primary"
                  disabled={isLoading}
                  onClick={handleCombinedSubmit}
                >
                  {isLoading && (
                    <GlobalLoader animation="grow" size="sm" variant="white" />
                  )}
                  {t('text.common.saveChanges')}
                </CommonButton>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (Array.isArray(details?.data) && details?.data?.length === 2) {
      return (
        <BusinessCard
          data={formData}
          ncaSignUp={ncaSignUp}
          ncaProfileKey={ncaProfileKey}
          loading={businessDetailLoader}
          provideEdit={provideEdit}
          onEdit={() => setIsEditing(true)}
        />
      );
    }

    if (Array.isArray(details?.data) && details?.data?.length === 1) {
      /*********Provider filled only business details not individual********* */
      /***********Open an model of ownership************************ */
      return (
        <>
          <BusinessCard
            data={formData}
            ncaSignUp={ncaSignUp}
            ncaProfileKey={ncaProfileKey}
            loading={businessDetailLoader}
            provideEdit={provideEdit}
            onEdit={() => setIsEditing(true)}
          />
        <ModalComponent
          title={t('text.provider.addPerson')}
          icon="icon ni ni-user-alt-fill"
          closable={false}
          show={showModal}
          onHandleCancel={onCloseModal}
        >
          <form>
            <Radio
              id="primary_representative"
              name="primary_representative"
              value="primary_representative"
              onChange={(e) => handleChange(e)}
              checked={radioType === 'primary_representative'}
            >
              <span htmlFor="primary_representative">
                {t('text.provider.primary_representative')}
              </span>
            </Radio>
            <br />
            <Radio
              id="percent_ownership"
              name="percent_ownership"
              value="percent_ownership"
              onChange={(e) => handleChange(e)}
              checked={radioType === 'percent_ownership'}
            >
              <span htmlFor="percent_ownership">
                {t('text.provider.percent_ownership')}
              </span>
            </Radio>
            <br />
            <Radio
              id="governing_board"
              name="governing_board"
              value="governing_board"
              onChange={(e) => handleChange(e)}
              checked={radioType === 'governing_board'}
            >
              <span htmlFor="governing_board">
                {t('text.provider.governing_board')}
              </span>
            </Radio>
            <br />
            <Radio
              id="senior_manager_executive"
              name="senior_manager_executive"
              value="senior_manager_executive"
              onChange={(e) => handleChange(e)}
              checked={radioType === 'senior_manager_executive'}
            >
              <span htmlFor="senior_manager_executive">
                {t('text.provider.senior_manager_executive')}
              </span>
            </Radio>
            <div className=" mt-2 text-end">
              <CommonButton
                onClick={() => onSubmitForm()}
                className="btn btn-primary"
              >
                {t('text.provider.saveAndContinue')}
              </CommonButton>
            </div>
          </form>
        </ModalComponent>
        <ModalComponent
          title={t('text.provider.businessType')}
          show={showForm}
          onHandleCancel={onCloseModal}
          extraClassName="modal-lg"
          onHeaderIconClick={onBack}
          icon="icon ni ni-arrow-left"
        >
          <div className="nk-block">
            <EditBusinessDetailsForm
              isStripeVerified={formData?.isStripeVerified}
              onSubmit={onSubmit}
              isLoading={isLoading}
              onCountryChange={onCountryChange}
              state={state}
              singleState={true}
              onStateChange={onStateChange}
              city={city}
              industryData={industryData}
              // formData={formData}
              setType={setType}
              type={type}
              countryCode={countryCode}
              radioType={radioType}
              ncaSignUp={ncaSignUp}
              ncaProfileKey={ncaProfileKey}
              modalSkip={false}
              ncaEdit={ncaEdit}
              isModal={true}
              provideEdit={provideEdit}
            />
          </div>
        </ModalComponent>
      </>
    );
  }
  }

  // Individual type: no UserBusinessDetail, only UserBusinessPersonDetail
  if (
    !isCompanyType &&
    (
      ['individual'].includes(formData?.Provider?.businessType) ||
      (['individual'].includes(formData?.Nca?.businessType) && ncaEdit) ||
      (['individual'].includes(formData?.Nca?.businessType) && ncaProfileKey)
    )
  ) {
    // Admin edit mode — individual business details
    if (provideEdit && isEditing) {
      return (
        <EditBusinessDetailsForm
          isStripeVerified={formData?.isStripeVerified}
          onSubmit={onSubmit}
          isLoading={isLoading}
          onCountryChange={onCountryChange}
          state={state}
          onStateChange={onStateChange}
          onSearchCity={onSearchCity}
          loader={loader}
          city={city}
          industryData={industryData}
          countryCode={countryCode}
          formData={formData?.UserBusinessPersonDetail}
          provideEdit={provideEdit}
          providerData={providerData}
          isAdminEdit={true}
          onCancel={() => {
            setIsEditing(false);
            setEditBusinessType(null);
          }}
          onBusinessTypeChange={(val) => setEditBusinessType(val)}
        />
      );
    }
    return (
      <BusinessCard
        data={formData}
        ncaSignUp={ncaSignUp}
        ncaProfileKey={ncaProfileKey}
        loading={businessDetailLoader}
        provideEdit={provideEdit}
        onEdit={() => setIsEditing(true)}
      />
    );
  }

  return (
    <EditBusinessDetailsForm
      isStripeVerified={formData?.isStripeVerified}
      onSubmit={onSubmit}
      isLoading={isLoading}
      onCountryChange={onCountryChange}
      state={state}
      onStateChange={onStateChange}
      onSearchCity={onSearchCity}
      loader={loader}
      city={city}
      industryData={industryData}
      setType={setType}
      type={type}
      countryCode={countryCode}
      ncaEdit={ncaEdit}
      nonIndevidualKey= {formData?.Nca ? true : false} 
      ncaSignUp={ncaSignUp}
      ncaProfileKey={ncaProfileKey}
      providerData={providerData}
    />
  );
}

export default BusinessDetails;

const BusinessCard = ({ data, ncaSignUp, ncaProfileKey, loading, provideEdit = false, onEdit }) => {
  const { t } = useTranslation();

  const openLink = (url) => window.open(url, '_newtab');
  const ownershipTypeObject = {
    primary_representative: t('text.provider.primary_representative'),
    percent_ownership: t('text.provider.percent_ownership'),
    governing_board: t('text.provider.governing_board'),
    senior_manager_executive: t('text.provider.senior_manager_executive'),
    saveAndContinue: t('text.provider.saveAndContinue'),
  };
  const { UserBusinessDetail, UserBusinessPersonDetail } = data;
  if (!UserBusinessDetail) {
    return !loading ? (
      <>
        <div className="card">
          <div className="card-inner">
            <div className="ncaBusinessDetails">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="title mb-0">{t(`text.common.businessDetails`)}</h5>
                {provideEdit && onEdit && (
                  <CommonButton
                    className="btn btn-sm btn-outline-primary"
                    onClick={onEdit}
                  >
                    <em className="icon ni ni-edit me-1"></em>
                    {t('text.common.edit')}
                  </CommonButton>
                )}
              </div>
              <div className="divider sm"></div>
              <IndividualCard
                UserBusinessPersonDetail={UserBusinessPersonDetail}
              />
            </div>
          </div>
        </div>
      </>
    ) : (
      <GlobalLoader />
    );
  }

  return !loading ? (
    <>
      <>
        <div className="card">
          <div className="card-inner">
            <div className="ncaBusinessDetails">
              {(!ncaSignUp || !ncaProfileKey) && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="title mb-0">
                      {t(`text.common.businessDetails`)}
                    </h5>
                    {provideEdit && onEdit && (
                      <CommonButton
                        className="btn btn-sm btn-outline-primary"
                        onClick={onEdit}
                      >
                        <em className="icon ni ni-edit me-1"></em>
                        {t('text.common.edit')}
                      </CommonButton>
                    )}
                  </div>
                  <div className="divider sm"></div>
                </>
              )}

              <Row>
                <Col lg={6}>
                  <ul className="list-unstyled mb-0">
                    <li>
                      <label className="sub-text">
                        {t(`text.common.companyName`)}
                      </label>
                      {UserBusinessDetail?.company || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.phoneNumber`)}
                      </label>
                      {UserBusinessDetail?.phoneNumber || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.addressLine1`)}
                      </label>
                      {UserBusinessDetail?.addressLine1 || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.state`)}
                      </label>
                      {UserBusinessDetail?.state || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.zipCode`)}
                      </label>
                      {UserBusinessDetail?.zipCode || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.industry`)}
                      </label>{' '}
                      <div className="d-flex flex-wrap">
                        {UserBusinessDetail?.UserBusinessIndustries &&
                        UserBusinessDetail?.UserBusinessIndustries?.length > 0
                          ? UserBusinessDetail?.UserBusinessIndustries?.filter(
                              (e) => e?.Industry
                            )?.map((e, idx) => (
                              <span key={idx} className="badge bg-light me-1">
                                {e?.Industry?.name}
                              </span>
                            ))
                          : '-'}
                      </div>{' '}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.ownershipType`)}
                      </label>
                      {UserBusinessDetail?.ownershipType ||
                      UserBusinessPersonDetail?.ownershipType
                        ? ownershipTypeObject[
                            UserBusinessDetail?.ownershipType ||
                              UserBusinessPersonDetail?.ownershipType
                          ]
                        : '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.businessTaxID`)}
                      </label>{' '}
                      {UserBusinessDetail?.taxId || '-'}
                    </li>
                  </ul>
                </Col>
                <Col lg={6}>
                  <ul className="list-unstyled">
                    <li>
                      <label className="sub-text">
                        {t(`text.common.employerIdentification`)}
                      </label>
                      {UserBusinessDetail?.employeeId || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.regBusinessAddress`)}
                      </label>
                      {UserBusinessDetail?.Country?.name || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.addressLine2`)}
                      </label>
                      {UserBusinessDetail?.addressLine2 || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.city`)}
                      </label>
                      {UserBusinessDetail?.city || '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.doingBusinessAss`)}
                      </label>
                      {firstLetterCaps(UserBusinessDetail?.doingBusinessAs) ||
                        '-'}
                    </li>
                    <li>
                      <label className="sub-text">
                        {t(`text.common.businessWebsite`)}
                      </label>{' '}
                      {/* <Link to={UserBusinessDetail?.businessWebsite}> */}
                      <Link onClick={() => openLink(UserBusinessDetail?.businessWebsite)}>
                        {UserBusinessDetail?.businessWebsite || '-'}
                      </Link>
                    </li>
                    <li>
                      <label className="sub-text">
                        {' '}
                        {t(`text.common.businessVatID`)}{' '}
                      </label>{' '}
                      {UserBusinessDetail?.vatId || '-'}
                    </li>
                  </ul>
                </Col>
              </Row>
              {UserBusinessPersonDetail && (
                <Row className="mt-3">
                  <Accordion defaultActiveKey="0" flush className="p-0 border">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div>
                          <h6>
                            {firstLetterCaps(
                              UserBusinessPersonDetail?.firstName
                            )}{' '}
                            {firstLetterCaps(
                              UserBusinessPersonDetail?.lastName
                            )}
                          </h6>
                          <p>
                            Representative, Owner,{` `}
                            {checkValidData(UserBusinessPersonDetail?.jobTitle)}
                          </p>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="p-3">
                        <Row className="mt-3">
                          <Col md={6}>
                            <ul className="list-unstyled mb-0">
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.percentOwnership`)}
                                </label>
                                {UserBusinessPersonDetail?.ownershipPercentage
                                  ? `${UserBusinessPersonDetail.ownershipPercentage}%`
                                  : '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.dateOfBirth`)}
                                </label>
                                {dateFormatter(
                                  UserBusinessPersonDetail?.dateOfBirth,
                                  ' MMMM D, YYYY'
                                ) || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.SSNLastFour`)}
                                </label>
                                {UserBusinessPersonDetail?.socialSecurityNumber ||
                                  '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {' '}
                                  {t(`text.common.homeAddress`)}
                                </label>{' '}
                                {UserBusinessPersonDetail?.Country?.name || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.addressLine2`)}
                                </label>
                                {UserBusinessPersonDetail?.addressLine2 || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.state`)}
                                </label>
                                {UserBusinessPersonDetail?.state || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.zipCode`)}
                                </label>
                                {UserBusinessPersonDetail?.zipCode || '-'}{' '}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.documentFront`)}
                                </label>{' '}
                                <span className="badge rounded-pill bg-primary">
                                  Verified
                                </span>{' '}
                              </li>
                              <li className="documentImg">
                                <ImageElement
                                  previewSource={
                                    UserBusinessPersonDetail?.identityDocumentFrontThumbUrl ||
                                    ''
                                  }
                                />
                              </li>
                            </ul>
                          </Col>
                          <Col md={6}>
                            <ul className="list-unstyled">
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.email`)}
                                </label>{' '}
                                {UserBusinessPersonDetail?.email || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.phoneNumber`)}
                                </label>
                                {UserBusinessPersonDetail?.phoneNumber || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.addressLine1`)}
                                </label>{' '}
                                {UserBusinessPersonDetail?.addressLine1 || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.city`)}
                                </label>{' '}
                                {UserBusinessPersonDetail?.city || '-'}
                              </li>
                              <li>
                                <label className="sub-text">
                                  {t(`text.common.documentBack`)}
                                </label>{' '}
                                <span className="badge rounded-pill bg-primary">
                                  Verified
                                </span>
                              </li>
                              <li className="documentImg">
                                <ImageElement
                                  previewSource={
                                    UserBusinessPersonDetail?.identityDocumentBackThumbUrl ||
                                    ''
                                  }
                                />{' '}
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Row>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  ) : (
    <GlobalLoader />
  );
};

const IndividualCard = ({ UserBusinessPersonDetail }) => {
  return (
    <>
      <Row>
        <Col md={6}>
          <ul className="list-unstyled mb-0">
            <li>
              <label className="sub-text">{t(`text.common.name`)}</label>
              {firstLetterCaps(UserBusinessPersonDetail?.firstName)}{' '}
              {firstLetterCaps(UserBusinessPersonDetail?.lastName)}
            </li>
            <li>
              <label className="sub-text">{t(`text.common.phoneNumber`)}</label>
              {UserBusinessPersonDetail?.phoneNumber || '-'}
            </li>
            {/* <li>
              <label className="sub-text">
                {t(`text.common.addressLine1`)}
              </label>{' '}
              {UserBusinessPersonDetail?.addressLine1 || '-'}
            </li> */}
            <li>
              <label className="sub-text">{t(`text.common.state`)}</label>
              {UserBusinessPersonDetail?.state || '-'}
            </li>
            <li>
              <label className="sub-text">{t(`text.common.zipCode`)}</label>
              {UserBusinessPersonDetail?.zipCode || '-'}{' '}
            </li>
            <li>
              <label className="sub-text">
                {t(`text.common.documentFront`)}{' '}
                <span className="badge rounded-pill bg-primary">Verified</span>{' '}
              </label>
              {/* <span className='badge rounded-pill bg-primary'>{UserBusinessPersonDetail?.socialSecurityNumber || "-"}</span>  */}
            </li>
            <li className="documentImg">
              <ImageElement
                previewSource={
                  UserBusinessPersonDetail?.identityDocumentFrontThumbUrl || ''
                }
              />
            </li>
          </ul>
        </Col>
        <Col md={6}>
          <ul className="list-unstyled">
            <li>
              <label className="sub-text">{t(`text.common.homeAddress`)}</label>{' '}
              {UserBusinessPersonDetail?.Country?.name || '-'}
            </li>

            <li>
              <label className="sub-text">
                {t(`text.common.addressLine1`)}
              </label>{' '}
              {UserBusinessPersonDetail?.addressLine1 || '-'}
            </li>
            <li>
              <label className="sub-text">{t(`text.common.city`)}</label>{' '}
              {UserBusinessPersonDetail?.city || '-'}
            </li>
            <li>
              <label className="sub-text">{t(`text.common.dateOfBirth`)}</label>
              {dateFormatter(
                UserBusinessPersonDetail?.dateOfBirth,
                'MMMM D, YYYY'
              ) || '-'}
            </li>
            <li>
              <label className="sub-text">
                {t(`text.common.documentBack`)}{' '}
                <span className="badge rounded-pill bg-primary">Verified</span>{' '}
              </label>
            </li>
            <li className="documentImg">
              <ImageElement
                previewSource={
                  UserBusinessPersonDetail?.identityDocumentBackThumbUrl || ''
                }
              />
            </li>
          </ul>
        </Col>
      </Row>
    </>
  );
};
